// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"f6e96f53","453":"db263a71"}[chunkId] + ".chunk.js";
};